module.exports = __webpack_public_path__ + "media/images/icons/photo_white-616e51d2d632e8335b78d836add2f3b0.svg";